/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TravelineResourceDto } from './traveline-resource-dto';
import {
    TravelineResourceDtoFromJSON,
    TravelineResourceDtoFromJSONTyped,
    TravelineResourceDtoToJSON,
    TravelineResourceDtoToJSONTyped,
} from './traveline-resource-dto';

/**
 * 
 * @export
 * @interface PreorderPropertyInfoDto
 */
export interface PreorderPropertyInfoDto {
    /**
     * Тип объекта размещения
     * @type {string}
     * @memberof PreorderPropertyInfoDto
     */
    type: PreorderPropertyInfoDtoTypeEnum;
    /**
     * Название объекта размещения
     * @type {string}
     * @memberof PreorderPropertyInfoDto
     */
    name: string;
    /**
     * Фотографии объекта размещения
     * @type {Array<TravelineResourceDto>}
     * @memberof PreorderPropertyInfoDto
     */
    images: Array<TravelineResourceDto>;
    /**
     * Адрес объекта размещения
     * @type {string}
     * @memberof PreorderPropertyInfoDto
     */
    address: string;
    /**
     * ID отеля
     * @type {string}
     * @memberof PreorderPropertyInfoDto
     */
    propertyId: string;
    /**
     * Количество звезд отеля
     * @type {number}
     * @memberof PreorderPropertyInfoDto
     */
    stars?: number | null;
}


/**
 * @export
 */
export const PreorderPropertyInfoDtoTypeEnum = {
    Hotel: 'hotel',
    Apartment: 'apartment'
} as const;
export type PreorderPropertyInfoDtoTypeEnum = typeof PreorderPropertyInfoDtoTypeEnum[keyof typeof PreorderPropertyInfoDtoTypeEnum];


/**
 * Check if a given object implements the PreorderPropertyInfoDto interface.
 */
export function instanceOfPreorderPropertyInfoDto(value: object): value is PreorderPropertyInfoDto {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('images' in value) || value['images'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('propertyId' in value) || value['propertyId'] === undefined) return false;
    return true;
}

export function PreorderPropertyInfoDtoFromJSON(json: any): PreorderPropertyInfoDto {
    return PreorderPropertyInfoDtoFromJSONTyped(json, false);
}

export function PreorderPropertyInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PreorderPropertyInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'name': json['name'],
        'images': ((json['images'] as Array<any>).map(TravelineResourceDtoFromJSON)),
        'address': json['address'],
        'propertyId': json['propertyId'],
        'stars': json['stars'] == null ? undefined : json['stars'],
    };
}

  export function PreorderPropertyInfoDtoToJSON(json: any): PreorderPropertyInfoDto {
      return PreorderPropertyInfoDtoToJSONTyped(json, false);
  }

  export function PreorderPropertyInfoDtoToJSONTyped(value?: PreorderPropertyInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'name': value['name'],
        'images': ((value['images'] as Array<any>).map(TravelineResourceDtoToJSON)),
        'address': value['address'],
        'propertyId': value['propertyId'],
        'stars': value['stars'],
    };
}

